// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2R-9O","col":"Table_col__2MlM7","fulfillmentStatus":"Table_fulfillmentStatus__2K2T5","emailCol":"Table_emailCol__22DVc"};